import {
  addMonths,
  addYears,
  format,
  isAfter,
  startOfMonth,
  startOfQuarter,
  startOfYear,
} from 'date-fns';

import { QUARTER } from './constants';

export interface DateItem {
  label: string;
  value: Date;
}
export function generateMonths(startDate: Date): DateItem[] {
  const today = new Date();
  const result: DateItem[] = [];
  let current = startOfMonth(startDate);

  while (!isAfter(current, today)) {
    result.push({
      label: format(current, 'MMMM yyyy'),
      value: current,
    });
    current = addMonths(current, 1);
  }

  return result;
}

export function generateQuarters(startDate: Date): DateItem[] {
  const today = new Date();
  const result: DateItem[] = [];
  let current = startOfQuarter(startDate);

  while (!isAfter(current, today)) {
    const quarter = Math.floor(current.getMonth() / QUARTER) + 1;
    result.push({
      label: `Q${quarter.toString()} ${current.getFullYear().toString()}`,
      value: current,
    });
    current = addMonths(current, QUARTER);
  }

  return result;
}

export function generateYears(startDate: Date): DateItem[] {
  const today = new Date();
  const result: DateItem[] = [];
  let current = startOfYear(startDate);

  while (!isAfter(current, today)) {
    result.push({
      label: current.getFullYear().toString(),
      value: current,
    });
    current = addYears(current, 1);
  }

  return result;
}
